//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TOGGLE_OTHER_SITES } from '@/scripts/store/footer'

export default {
  name: 'rb-footer-other-sites-link-container',
  props: {
    text: String,
  },
  methods: {
    isVisible() {
      return this.$store.state.footer.otherSites
    },
    toggle() {
      return this.$store.commit(TOGGLE_OTHER_SITES)
    },
  },
}
